import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appBloquearPegadoNegativo]',
    standalone: false
})
export class BloquearPegadoNegativoDirective {

  constructor() { }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') || '';
    const valorPegado = clipboardData.trim();
    if (valorPegado.startsWith('-')) {
      event.preventDefault();
    }
  }
}